module.exports = __webpack_public_path__ + "img/dev.fbf31e3d.png";